import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="flex min-h-[80vh] items-center" data-testid="not-found">
      <Seo title="Page not found" description="This page doesn't exist in the Barverse." path="/404" />
      <div className="container-x">
        <p className="eyebrow">404</p>
        <h1 className="mt-5 font-display text-6xl uppercase leading-[0.9] text-bv-ink sm:text-8xl">
          Lost in the verse.
        </h1>
        <p className="mt-6 max-w-md text-lg leading-relaxed text-bv-sub">
          That page doesn't exist. The bar, however, does.
        </p>
        <Link to="/" className="btn-primary mt-10" data-testid="not-found-home">
          Back to the Barverse
        </Link>
      </div>
    </div>
  );
}
